/**
 * Created by aaikepae on 11/3/16.
 */
import React from "react"
import {connect} from "react-redux"
import {bindActionCreators} from 'redux';
import DOMPurify from "dompurify";

import {getActAsPartnerAccess, loadJSFile} from "../../../common/utility/utils";

import {loadContent} from "../../actions/content";

import SearchList from "./SearchList"
import Static from "./contentType/Static"
import HTML from "./contentType/HTML"
import { shouldUseWebComponent, WebComponent } from "./contentType/Webcomponent"
import MyApps from "../MyApps/MyApps";
import Loader from "../../../common/base/Loader/Loader";
import ActAsPartnerAccessError from "../../../common/base/ActAsPartnerAccessError/ActAsPartnerAccessError";
import PortalError from "../../../../widgets/microsite/portalError/portalError";

// import Footer from "./Foorter"
// import {Code} from "./Code";

export class Content extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            canOpenSelectedFile: false
        };
        this.rootRef = React.createRef();
        this.docRef = React.createRef();
        this.selectedFileUrl = null;
        this.handleOpenSelectedFile = this.handleOpenSelectedFile.bind(this);
    }

    componentDidMount() {
        const {selected} = this.props;
        console.log(selected)
        if (selected["item"] && !selected.data) {
            this.props.loadContent(selected.item);
        }

        this.updateSelectedFileState(this.props);
    }

    componentDidUpdate(prevProps) {
        const { selected, config } = this.props;
        //when select item, trigger content generation
        if (selected["item"] && !selected.data && selected["item"] !== prevProps.selected["item"]) {
            this.props.loadContent(selected.item);
        }
        if (config.useNPS && config.useNPS !== prevProps.config.useNPS) {
            loadJSFile(CONFIG.NPS_SDK).then(() => {
                if (window.NpsSDK) {
                    window.NpsSDK.loadForm(config.useNPS);
                }
            })
        }

        if (selected.item !== prevProps.selected.item || config.location !== prevProps.config.location) {
            this.updateSelectedFileState(this.props);
        }
    }

    getSafeBaseLocation(baseLocation) {
        const safeBase = typeof baseLocation === "string" ? baseLocation.trim() : "";

        try {
            const parsedBase = new URL(safeBase, window.location.origin);
            if (parsedBase.protocol !== "http:" && parsedBase.protocol !== "https:") {
                return null;
            }
            return parsedBase.toString();
        } catch (e) {
            return null;
        }
    }

    sanitizeFilePath(filePath) {
        const safePath = typeof filePath === "string" ? filePath.trim() : "";
        if (!safePath) {
            return null;
        }

        if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/i.test(safePath) || safePath.startsWith("//")) {
            return null;
        }

        if (!/^[a-zA-Z0-9/_.,?&=#%+\-~]*$/.test(safePath)) {
            return null;
        }

        return encodeURI(safePath);
    }

    getSafeFileUrl(baseLocation, filePath) {
        const safeBase = this.getSafeBaseLocation(baseLocation);
        const safePath = this.sanitizeFilePath(filePath);
        if (!safeBase || !safePath) {
            return null;
        }

        try {
            const url = new URL(safePath, safeBase);
            if (url.protocol !== "http:" && url.protocol !== "https:") {
                return null;
            }
            return url.toString();
        } catch (e) {
            return null;
        }
    }

    resolveSelectedFileUrl(props = this.props) {
        if (props?.selected?.item?.type !== "file") {
            return null;
        }

        const baseLocation = props?.config?.location;
        const filePath = props?.selected?.item?.content;

        return this.getSafeFileUrl(baseLocation, filePath);
    }

    openFileUrl(fileUrl) {
        if (!fileUrl) {
            return false;
        }

        window.open(fileUrl, "_blank", "noopener,noreferrer");
        return true;
    }

    handleOpenSelectedFile() {
        return this.openFileUrl(this.selectedFileUrl);
    }

    // Returns true/false for boolean-ish values, null when the flag is not set
    resolveFlag(value) {
        if (typeof value === "boolean") {
            return value;
        }
        if (typeof value === "string") {
            const normalized = value.trim().toLowerCase();
            if (normalized === "true" || normalized === "1") {
                return true;
            }
            if (normalized === "false" || normalized === "0" || normalized === "") {
                return false;
            }
        }
        return null;
    }

    updateSelectedFileState(props) {
        const nextFileUrl = this.resolveSelectedFileUrl(props);
        const nextCanOpenSelectedFile = Boolean(nextFileUrl);

        this.selectedFileUrl = nextFileUrl;

        if (this.state.canOpenSelectedFile !== nextCanOpenSelectedFile) {
            this.setState({ canOpenSelectedFile: nextCanOpenSelectedFile });
        }
    }

    render() {

        const {selected, config, items, search, router} = this.props;
        const { canOpenSelectedFile } = this.state;

       if (selected.itemURL && selected.itemURL === 'my_apps') {

       } else if (!items || items.length == 0) {
            console.log(selected)
            return <><Loader/></>
        } else if (search["keyword"]) {
            console.log(selected)
            return <div className="pubhub-doc-container pubhub-search-container">
                <section>
                    <SearchList router={router} />
                </section>
            </div>
        } else if (!selected["data"] || !selected.item) {
            
            return  <>
            <div className="pubhub-doc-container"></div>
            <Loader/>
            </>;
        }


        //bottom navigation
        let child, isIncludeWidget;
        const type = selected.item.type;



        if (type == "file") {
            child =
                <p>
                    Please click {canOpenSelectedFile
                        ? <button type="button" onClick={this.handleOpenSelectedFile}>here</button>
                        : <span>here</span>} to open this file.
                </p>;

        } else if (["html", "swagger", "raml"].indexOf(type) !== -1) {
            child = <HTML
                selected={selected}
                data={selected["data"]}
                config={config}
                router={router}
                ref={this.docRef}
            />;

        } else if (shouldUseWebComponent(type)) {
            child = <WebComponent
                selected={selected}
                data={selected["data"]}
                config={config}
                ref={this.docRef}
            ></WebComponent>
        } else if(selected.itemURL && selected.itemURL === 'my_apps') {
                if(getActAsPartnerAccess('my_apps')) {
                    // will change it once design is ready
                    child = <ActAsPartnerAccessError />
                } else {
                    child =  <>
                        <div className="column-doc column-doc-static">
                            <MyApps selected={selected} config ={config} items={items}/>
                        </div>
                    </>
                }
                isIncludeWidget = true
        }else {
                        child = <Static
                            key={selected.orphenLinkUrl || 'normal-static'}
                            selected={selected}
                            data={selected["data"]}
                            config={config}
                            dispatch={this.props.dispatch}
                            router={router}
                            onStartLoadOrphenLink={this.props.onStartLoadOrphenLink}
                            onOrphenLinkGoback={this.props.onOrphenLinkGoback}
                            ref={this.docRef}
                        />;

            isIncludeWidget = true
        }
        // const footer = <Footer config={this.props.config} selected={this.props.selected}/>;
        const widgetID = isIncludeWidget ? "pubhub-widgets" : "";

        let codeLayoutClass = config.codeLayout;
        if ((codeLayoutClass == "two-columns" && config["_platform"] !== "lg") || (selected.codeSections && selected.codeSections.length == 0)) {
            codeLayoutClass = "one-column"
        }
        const widgetClass = ["doc-content", type, codeLayoutClass].join(" ");

        let userAccessLevel = window.sessionStorage.getItem("accessLevel") ?? 0;
        const selectedItemTitle = selected.item.url;
        const parentItem = items.find(item => 
            item.children?.some(child => child === selectedItemTitle)
            );

        const itemAccessLevel = parentItem?.accessLevel ?? 0;

        // web.json / page config can deliver this flag as a string ("false", "0"), so coerce explicitly
        const itemConfigShowSectionFooter = this.resolveFlag(selected?.item?.config?.showSectionFooter);
        const itemSectionFooter = selected?.item?.config?.sectionFooter;
        const showSectionFooter = itemConfigShowSectionFooter !== null
            ? itemConfigShowSectionFooter
            : (typeof itemSectionFooter === "string" && itemSectionFooter.trim() !== "")
                || this.resolveFlag(config.showSectionFooter) === true;
        const sectionFooterHTML = typeof itemSectionFooter === "string"
            ? itemSectionFooter
            : (typeof config.sectionFooter === "string" ? config.sectionFooter : "");
        const contentContainerClass = [
            "pubhub-doc-container",
            config.layout,
            showSectionFooter ? "has-section-footer" : ""
        ].filter(Boolean).join(" ");

        let originalHTML = `<portalError type="" height="height-80">
        <title>Access Restricted</title>
        <message>You do not have access to view this page.</message>
        <imageSrc width="300px" height="300px">restricted</imageSrc>
        </portalError>`
        const wrapper = document.createElement("div");
        wrapper.innerHTML = originalHTML;
        const errorConfig = wrapper;

        return (
            <div className={contentContainerClass} ref={this.rootRef}>
                <section className={widgetClass} id={widgetID}>
                    {itemAccessLevel > userAccessLevel ? <PortalError config={errorConfig} /> : child }
                </section>
                {showSectionFooter && <div
                    className="pubhub-section-footer"
                    dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(sectionFooterHTML)}}
                ></div>}
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        loadContent: bindActionCreators(loadContent, dispatch)
    };
}

export default connect(null, mapDispatchToProps, null, {forwardRef: true})(Content);
